import { Box, Typography, Link } from '@mui/material';
import { styled } from '@mui/system';

export const Grid = styled(Box)(({ theme, gap, margin }) => ({
  display                        : 'grid',
  maxWidth                       : '1396px',
  gridTemplateColumns            : 'repeat(2, 1fr)',
  margin                         : margin || '50px auto 0 auto',
  gap                            : gap || '120px',
  [theme.breakpoints.down('sm')] : {
    gridTemplateColumns : '1fr',
    gap                 : '30px',
  },
}));

export const GridItem = styled(Box)(({ padding, gap }) => ({
  display       : 'flex',
  flexDirection : 'column',
  padding       : padding || '0 10px',
  gap           : gap || 0,
  img           : {
    borderRadius : '10px',
    width        : '100%',
  },
}));

export const Title = styled(Typography)({
  fontSize     : '1rem',
  marginBottom : '20px',
});

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize : '14px',
  color    : theme.palette.primary.gray6,
}));

export const Text = styled(Typography)({
  fontSize   : '1rem',
  fontFamily : 'Montserrat',
});

export const ContactInfo = styled(Typography)({
  fontSize   : '14px',
  fontFamily : 'Montserrat',
});

export const ButtonContainer = styled(Box)({
  textAlign    : 'center',
  marginBottom : '20px',
});

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration : 'none',
  color          : theme.palette.primary.blue1,
  display        : 'flex',
  alignItems     : 'center',
  svg            : {
    marginRight : '5px',
  },
}));

export const StyledGrid = styled(Grid)(({ theme }) => ({
  textDecoration : 'none',
  color          : theme.palette.primary.blue1,
  fontFamily     : 'Montserrat',
  svg            : {
    marginRight : '5px',
  },
}));
